<template>
  <div class="home_about">
    <div class="gsjj">
      <p class="p1">公司简介</p>
      <div class="fg"></div>
    </div>
    <div class="text">
      <p class="text_p1">
        杭州越璋文化传媒有限公司成立于2017年7月，注册地在于最具创业创新活力的杭州市。在以移动互联网、大数据、云计算、人工智能为代表的新一代信息化浪潮中，公司聚焦于泛金融大科技、政企数字化领域，以人才和技术为核心，以科技服务和技术VC为抓手，乘风破浪，扬帆起航。
      </p>
      <p class="text_p2">
        公司秉承“重诺守信、严谨求是”的企业精神和“以人为本，客户至上”的经营理念，致力于金融科技、智能物联网、电子商务等行业的信息化建设，帮助客户通过科技降低成本、提升效率，增强其在新时代的市场竞争力。
      </p>
      <a class="ljgd" href="/about">
        <span>查看更多</span>
      </a>
    </div>
    <!-- <div class="init">
      <div class="title">/ 关于泛钛 /</div>
      <div class="title2">科技服务金融，人才成就梦想</div>
      <div class="cont">
        <div class="img">
          <img src="../../assets/images/home/img1.png" alt="">
        </div>
        <div class="info">
          <div class="title3">杭州越璋文化传媒有限公司</div>
          <div class="text">
            <p>
              泛钛科技有限公司成立于2017年7月，注册地位于最具创业创新活力的杭州市滨江区。在以移动互联网、大数据、云计算、人工智能为代表的新一代信息化浪潮中，公司聚焦于泛金融大科技领域，以人才和技术为核心，以科技服务和技术VC为抓手，乘风破浪，扬帆起航。
            </p>
            <p>
              公司秉承“重诺守信、严谨求是”的企业精神和“以人为本，客户至上”的经营理念，致力于金融科技、智能物联网、电子商务等行业的信息化建设，帮助客户通过科技降低成本、提升效率，增强其在新时代的市场竞争力。
            </p>
            <a class="more" href="/about">
              <span>了解更多</span>
              <icon name="caret-right" fill="#073875"></icon>
            </a>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>-->
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    bannerList: {
      type: Array,
      default() {
        return [];
      },
    },
    myString: {
      type: String,
      default: "111",
    },
  },
};
</script>

<style lang="scss" scoped>
.clear {
  clear: both;
}

.home_about {
  width: 100%;
  height: 650px;
  background: linear-gradient(to bottom, white 20%, white);
  // padding-top: 0.5rem;
  // background-color: #f10065;
}
.gsjj {
  width: 208px;
  height: 99px;
  // background-color: #073875;
  margin: 0 auto;
  padding-top: 83px;
  // margin-top: 100px;
  margin-bottom: 80px;
}
.fg {
  width: 165px;
  height: 5px;
  background: #0a41ff;
  border-radius: 0px 0px 0px 0px;
  margin: 47px 21px 0px 22px;
}
.text {
  height: 332px;
  width: 1600px;
  margin: 0 auto;
  // margin-top: 80px;
  background-color: #fff;
}
.p1 {
  width: 208px;
  height: 52px;
  font-size: 52px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  background-color: rgba(255, 255, 255, 0);

  line-height: 93px;
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
}
.text_p1 {
  text-indent: 2em;
  width: 1600px;
  height: 65px;
  line-height: 35px;
  font-size: 24px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  background-color: rgba(255, 249, 249, 0);

  // background-color: rgba(255, 255, 255, 0.5); /* 使用 RGBA 表示红色，0.5 表示 50% 的透明度 */
  color: #666666;
  // line-height: 0px;
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
}
.text_p2 {
  text-indent: 2em;
  margin-top: 42px;
  width: 1600px;
  height: 65px;
  line-height: 35px;
  font-size: 24px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  // background-color: rgba(255, 252, 252, 0.5); /* 使用 RGBA 表示红色，0.5 表示 50% 的透明度 */
  color: #666666;
  // line-height: 0px;
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
}
.ljgd {
  display: block; /* 改为块级元素，以使其宽度自动适应父元素 */
  text-align: center; /* 文本居中对齐 */
  margin-top: 78px; /* 上边距为75px */
  margin-bottom: 0; /* 下边距为0 */
  font-size: 28px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #0a41ff;
  text-decoration: none; /* 去掉链接的下划线 */
}

.init {
  width: 80%;
  margin: 0.5rem auto;
  padding: 1rem 0 0.8rem;
  background-image: url(../../assets/images/home/bg1.png);
  background-size: cover;
  max-width: 1196px;
  border-radius: 8px;
}

.title {
  color: #073875;
  line-height: 0.48rem;
  font-size: 0.48rem;
  text-align: center;
}

.title2 {
  margin-top: 0.15rem;
  color: #333;
  line-height: 0.18rem;
  font-size: 0.18rem;
  text-align: center;
}

.title3 {
  color: #333;
  font-weight: 600;
  line-height: 0.22rem;
  font-size: 0.22rem;
}

.cont {
  margin-top: 0.6rem;
}

.img {
  width: 50%;
  margin-left: -3%;
  float: left;
}

.img img {
  width: 100%;
}

.info {
  width: 50%;
  float: right;
}

.text {
  // width: 95%;
  // margin-top: 0.2rem;
  line-height: 0.3rem;
  font-size: 0.15rem;
  text-indent: 2em;
  color: #666;
}

.more {
  margin-top: 0.2rem;
  padding: 0 0.4rem;
  line-height: 0.4rem;
  color: #073875;
  border: 1px solid #073875;
  background-color: #fff;
  text-align: center;
  text-indent: 0;
  float: left;
  border-radius: 0.25rem;
}

.more:hover {
  border: 1px solid #073875;
  background-color: #eee;
}

.more svg,
.more span {
  vertical-align: middle;
}

.more svg {
  margin-left: 5px;
}

@media screen and (min-width: 1366px) and (max-width: 1920px) {
  // .home_about {
  //   width: 100%;
  //   height: 650px;
  //   background: linear-gradient(to bottom, white 20%, white);
  //   // padding-top: 0.5rem;
  //   // background-color: #f10065;
  //   .gsjj {
  //     width: 11%;
  //     height: 99px;
  //     // background-color: #073875;
  //     margin: 0 auto;
  //     padding-top: 83px;
  //     // margin-top: 100px;
  //     margin-bottom: 80px;
  //     .p1 {
  //       width: 11%;
  //       font-size: 2rem;
  //     }
  //   }
  //   .fg {
  //     width: 165px;
  //     height: 5px;
  //     background: #0a41ff;
  //     border-radius: 0px 0px 0px 0px;
  //     margin: 47px 21px 0px 22px;
  //   }
  // }
  // .title {
  //   line-height: 0.8rem;
  //   font-size: 0.8rem;
  // }

  // .title2 {
  //   margin-top: 0.3rem;
  //   line-height: 0.4rem;
  //   font-size: 0.4rem;
  // }

  // .title3 {
  //   color: #333;
  //   line-height: 0.5rem;
  //   font-size: 0.5rem;
  //   text-align: center;
  // }

  // .img {
  //   width: 80%;
  //   margin: 0 auto 0.5rem;
  //   float: none;
  // }

  // .info {
  //   width: 80%;
  //   margin: 0 auto;
  //   float: none;
  // }

  // .cont {
  //   margin-top: 0.6rem;
  // }

  // .text {
  //   margin-top: 0.4rem;
  //   line-height: 0.5rem;
  //   font-size: 0.35rem;
  // }

  // .text p {
  //   margin-bottom: 0.2rem;
  // }

  // .more {
  //   padding: 0 0.6rem;
  //   line-height: 0.8rem;
  //   font-size: 0.35rem;
  //   border-radius: 0.5rem;
  //   float: right;
  // }
}
</style>
